import { Card, Row, Col, Progress, Statistic, Space } from "antd"
import {
  CheckCircleOutlined,
  ArrowUpOutlined,
} from "@ant-design/icons"
import Highcharts from "highcharts"
import HighchartsReact from "highcharts-react-official"
import HighchartsMore from "highcharts/highcharts-more"
import HighchartsHeatmap from "highcharts/modules/heatmap"

// Initialize Highcharts modules
HighchartsMore(Highcharts)
HighchartsHeatmap(Highcharts)

const AccuracyScore = () => {


  const accuracyChart = {
    chart: { type: "gauge", height: 300 },
    title: { text: "Live Execution Accuracy Score" },
    pane: {
      startAngle: -90,
      endAngle: 90,
      background: [
        {
          backgroundColor: "#EEE",
          innerRadius: "60%",
          outerRadius: "100%",
          shape: "arc",
        },
      ],
    },
    yAxis: {
      min: 0,
      max: 100,
      tickPixelInterval: 72,
      tickPosition: "inside",
      tickColor: "#666",
      tickLength: 20,
      tickWidth: 2,
      minorTickInterval: null,
      labels: { distance: 20, style: { fontSize: "14px" } },
      plotBands: [
        {
          from: 0,
          to: 60,
          color: "#DF5353",
        },
        {
          from: 60,
          to: 80,
          color: "#DDDF0D",
        },
        {
          from: 80,
          to: 100,
          color: "#55BF3B",
        },
      ],
    },
    series: [
      {
        name: "Accuracy",
        data: [87],
        tooltip: { valueSuffix: "%" },
        dataLabels: {
          format: "{y}%",
          borderWidth: 0,
          color: "#333",
          style: { fontSize: "16px" },
        },
        dial: {
          radius: "80%",
          backgroundColor: "silver",
          baseWidth: 12,
          baseLength: "0%",
          rearLength: "0%",
        },
        pivot: {
          backgroundColor: "silver",
          radius: 6,
        },
      },
    ],
  }
  return (
    <Card
        title={
          <Space>
            <CheckCircleOutlined style={{ color: "#52c41a" }} />
            <span>Live Execution Accuracy Score</span>
          </Space>
        }
        style={{ marginTop: "24px" }}
      >
        <Row gutter={[24, 24]}>
          <Col xs={24} lg={12}>
            <HighchartsReact highcharts={Highcharts} options={accuracyChart} />
          </Col>
          <Col xs={24} lg={12}>
            <Space direction="vertical" size="large" style={{ width: "100%" }}>
              <Statistic
                title="Current Accuracy Score"
                value={87}
                suffix="%"
                valueStyle={{ color: "#3f8600" }}
                prefix={<CheckCircleOutlined style={{ color: "#52c41a" }} />}
              />
              <Statistic title="Confidence Band" value="±3.2%" valueStyle={{ color: "#1890ff" }} />
              <Statistic
                title="30-Day Trend"
                value={"+5.4%"}
                valueStyle={{ color: "#3f8600" }}
                prefix={<ArrowUpOutlined />}
              />
              <Progress
                percent={87}
                strokeColor={{
                  "0%": "#108ee9",
                  "100%": "#87d068",
                }}
              />
            </Space>
          </Col>
        </Row>
      </Card>
  )
}

export default AccuracyScore